import { connect } from 'react-redux'
import get from 'lodash/get';

import {
  deleteReport as onDeleteReport
} from './../../actions/deleteReportActions'

const mapStateToProps = (state) => ({
  deleteReportDataState: state.deleteReport.dataState,
  deleteReportId: state.deleteReport.deleteId,
  deleteReportErrors: get(state, ['deleteReport', 'errors', 'data', null])
})

const mapDispatchToProps = {
  onDeleteReport
}

const withDeleteReport = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withDeleteReport }